





























































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { ContactAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { escapeHtml } from '@/helpers/html'

@Component
export default class ContactInformation extends Vue {
    @Prop({ required: true }) readonly referral!: Referral

    modalEditContact: boolean = false
    modalEditContactSpouse: boolean = false
    submittingEditContact: boolean = false
    showMoreDetails: boolean = false

    get componentClass() {
        return {
            'contact-information': true,
        }
    }

    get variables() {
        return {
        }
    }

    showMoreDetailsToggle() {
        this.showMoreDetails = !this.showMoreDetails
    }

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.referral || !this.referral.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.referral.assignedToBranch.company.id
    }

    get contact() {
        if (!this.referral || !this.referral.contact) {
            return null
        }

        return this.referral.contact
    }

    async updateContact(onComplete: () => {}) {
        this.submittingEditContact = true

        try {
            await ContactAPI.update(this.contact.id, this.contact)
            // @todo: instead of editing the "live" record, copy it and edit that
            // @todo: then once complete, replace the referral contact
            // @todo: should feel more robus for the user, since now pressing cancel still shows the changes.
            onComplete()

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submittingEditContact = false
        }
    }
}


